import { getGap } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneSize } from '@Components/BigBrowse/Model/ModelTypes';
import { get2ColumnsWidth } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/columnCalculator';
import type { ViewData } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import { getMultiSectionDescriptionCards } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/common/descriptionCards';
import {
  getCentralIndex,
  getCentralIndexes,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/header/headerFullWidth/helpers/headerFullWidth.helpers';
import { isOdd } from '@Utils/miscUtils';

export async function addHeaderDescription(
  viewData: ViewData
): Promise<ViewData> {
  const { layoutTable } = viewData;

  const textSize = getTextSize(viewData);
  const gapSize = {
    width: viewData.columnWidth!,
    height: textSize.height,
  };

  const numOfColumns = layoutTable!.length;
  const [textColumnIndex, gapColumnIndex] = getTextColumnIndexes(numOfColumns);

  // if there is an odd number of columns, push the column a bit to the right
  const dx = isOdd(viewData.layoutTable!.length)
    ? viewData.columnWidth! / 2
    : 0;
  layoutTable![textColumnIndex].push(
    getMultiSectionDescriptionCards({ viewData, size: textSize, dx })
  );

  layoutTable![gapColumnIndex].push(getGap(gapSize));

  // add optional central gap
  if (isOdd(numOfColumns)) {
    layoutTable![getCentralIndex(numOfColumns)].push(getGap(gapSize));
  }

  return viewData;
}

function getTextColumnIndexes(numOfColumns: number): [number, number] {
  return getCentralIndexes(numOfColumns).slice(0, 2) as [number, number];
}

function getTextSize(viewData: ViewData): PlaneSize {
  const side = get2ColumnsWidth(viewData);

  return { width: side, height: side };
}
